import { useQuery } from "@tanstack/react-query";
import { getWhatsAppContact } from "@/lib/contact";

/**
 * Porté depuis apps/web/app/(shop)/mentions-legales/page.tsx (Server
 * Component async) — devenu un composant client utilisant TanStack Query
 * pour résoudre le contact WhatsApp (même pattern que `SiteFooter` /
 * `ContactPage`), `generateMetadata` abandonné (hors périmètre — cf. lot
 * SEO/prérendu séparé).
 */
export function MentionsLegalesPage() {
  const { data: whatsapp } = useQuery({
    queryKey: ["settings", "whatsapp-contact"],
    queryFn: getWhatsAppContact,
  });

  return (
    <div className="container-vvs py-8 lg:py-12">
      <h1 className="font-display text-2xl font-bold text-navy sm:text-3xl">Mentions légales</h1>
      <div className="mt-4 max-w-prose space-y-6 font-body text-sm leading-relaxed text-muted">
        <div>
          <h2 className="font-display text-base font-semibold text-ink">Éditeur du site</h2>
          <p className="mt-1">
            Le site VVS — Vendez-Vous eShop est édité par Vendez-Vous eShop (VVS), marketplace en
            ligne opérant en Côte d&apos;Ivoire.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Contact</h2>
          <p className="mt-1">
            Pour toute question relative au site ou à son contenu, contactez VVS sur WhatsApp au{" "}
            {whatsapp?.display ?? "[numéro indisponible]"}, ou via la page Contact.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Hébergement</h2>
          <p className="mt-1">
            Le site est hébergé sur une infrastructure serveur dédiée (environnement conteneurisé
            administré via une plateforme de gestion de serveur), en Côte d&apos;Ivoire ou dans un
            pays offrant des garanties équivalentes.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Propriété intellectuelle</h2>
          <p className="mt-1">
            L&apos;ensemble des éléments du site (textes, logo, mise en page) est protégé au titre
            de la propriété intellectuelle. Les visuels et descriptions de produits restent la
            propriété de leurs vendeurs ou fournisseurs respectifs.
          </p>
        </div>

        <p className="border-t border-line pt-4 text-xs text-muted/80">
          Ce texte constitue un cadre général structurant, rédigé pour refléter le fonctionnement
          actuel du site. Il ne constitue pas un document juridique définitif et doit être validé
          par un professionnel du droit avant toute mise en production définitive.
        </p>
      </div>
    </div>
  );
}
